'use client'

import { useMutation } from '@apollo/client'
import { EditableField } from '@chain-zen/ui'
import { toast } from 'sonner'

import { CHANGE_SHIPMENT_NUMBER } from '../../../../data/mutations/shipment'

interface ChangeShipmentNumberProps {
  canEdit: boolean
  shipmentID: string
  shipmentNumber: string
  shipmentOwnerWorkspaceId: string
  variant?: 'default' | 'large'
}

/**
 * This component is used to display and edit the shipment number.
 * It uses the shipment number to display and edit the shipment number.
 */
const ShipmentNumber = ({
  canEdit,
  shipmentNumber,
  shipmentOwnerWorkspaceId,
  shipmentID,
  variant = 'default'
}: ChangeShipmentNumberProps) => {
  const [changeShipmentNumber, { loading: isChangingShipmentNumber }] = useMutation(CHANGE_SHIPMENT_NUMBER, {
    context: {
      headers: {
        'ws-id': shipmentOwnerWorkspaceId
      }
    },
    onCompleted() {
      toast.success('Shipment number updated successfully')
    },
    onError(error) {
      toast.error(error.message)
    }
  })

  const handleChangeShipmentNumber = (newShipmentNumber: string) => {
    toast.info('Updating shipment number...')
    changeShipmentNumber({
      variables: {
        id: shipmentID,
        shipmentNumber: newShipmentNumber
      }
    })
  }
  return (
    <EditableField
      value={shipmentNumber}
      onSubmit={handleChangeShipmentNumber}
      canEdit={canEdit}
      isLoading={isChangingShipmentNumber}
      variant={variant}
      containerClassName="w-full"
      tooltipContent="Click to edit shipment number"
    />
  )
}

export { ShipmentNumber }
